import { useSettings } from 'core/hooks/settings/useSettings'
import React from 'react'
import { CompanyType } from 'types/misc'

/**
 * Props for the CompanyToggle component.
 */
interface CompanyToggleProps {
  /**
   * The company to check for ('everlance' or 'motus').
   */
  company: CompanyType
  /**
   * The children to render if the toggle passes.
   */
  children?: React.ReactNode
}

/**
 * Conditionally renders children based on company and feature-flag.
 */
const CompanyToggle = ({ company, children }: CompanyToggleProps) => {
  const {
    data: {
      featureFlags: { ENABLE_DRIVER_EXPERIENCE }
    }
  } = useSettings()
  if (!ENABLE_DRIVER_EXPERIENCE && company === 'everlance') {
    return <>{children}</>
  }

  if (ENABLE_DRIVER_EXPERIENCE && company === 'motus') {
    return <>{children}</>
  }
  return null
}

export default CompanyToggle
